import api from "./index";

export interface ContractorsListParams {
  type?: "juridical" | "physical";
  companyId?: string;
  userIds?: Array<string>;
  responsibleIds?: Array<string>;
  searchJuridical?: string;
  searchPhysical?: string;
  title?: string;
  shortTitle?: string;
  inn?: string;
  snils?: string;
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  studentIds?: Array<string>;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?:
    | "title"
    | "shortTitle"
    | "inn"
    | "email"
    | "phone"
    | "firstName"
    | "middleName"
    | "lastName"
    | "createdAt"
    | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: ContractorsListParams, options?: any) => {
  return api.ContractorApi.listContractorNew(
    params.type,
    params.companyId,
    params.userIds,
    params.responsibleIds,
    params.searchJuridical,
    params.searchPhysical,
    params.title,
    params.shortTitle,
    params.inn,
    params.snils,
    params.email,
    params.phone,
    params.firstName,
    params.lastName,
    params.middleName,
    params.studentIds,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
